export default __webpack_public_path__ + "static/media/hiddenfoil.80005f58.svg";